import { BaseModel } from './BaseModel';

export class Upload extends BaseModel {
  static get entity() {
    return 'uploads';
  }

  static fields() {
    return {
      id: this.uid()
    };
  }

  static apiConfig = {
    actions: {
      upload(formData) {
        return this.post(`/upload`, formData);
      },

      deleteFile(id) {
        return this.delete(`/upload/files/${id}`, { delete: id });
      },

      uploadFiles(ref, refId, field, files) {
        const formData = new FormData();
        formData.append('ref', ref);
        formData.append('refId', refId);
        formData.append('field', field);
        files.forEach((file) => formData.append('files', file));
        return this.post('/upload', formData);
      },

      createS3Upload({
        key,
        name,
        url,
        mime,
        size,
        ref,
        refId,
        field,
        source = undefined,
        isPublic = false
      } = {}) {
        return this.post('/upload/s3', {
          key,
          name,
          url,
          mime,
          size,
          ref,
          refId,
          field,
          source,
          isPublic
        });
      },
      async fetchPresignedUrl(fileId, params = {}) {
        return this.get(`/files/${fileId}/presigned-url`, {
          params,
          save: false
        });
      },

      async fetchPublicPresignedUrl(fileId, params = {}) {
        return this.get(`/public/files/${fileId}/presigned-url`, { params, save: false });
      },

      async downloadFile(fileId) {
        return this.get(`/files/${fileId}/download`, {
          save: false
        });
      },

      async downloadReceipt(receiptId) {
        return this.get(`/receipts/${receiptId}/download`, {
          save: false
        });
      }
    }
  };
}

export default Upload;
